// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: "AIzaSyBD-2v5iCjIYJxevXIqncAMNTEZ4lYT1RE",
    authDomain: "server-account-manager.firebaseapp.com",
    databaseURL: "https://server-account-manager.firebaseio.com",
    projectId: "server-account-manager",
    storageBucket: "server-account-manager.appspot.com",
    messagingSenderId: "25304104027",
    appId: "1:25304104027:web:6b9e110f2012a70a80537e"
  },
  secretPassphrase: '@lhUxCwq3PGV&$zosO$g18NWTLlY^6th'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
